var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommonIconWrite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.826 1.51l2.782 2.793-5.818 5.911H0v-2.8L5.826 1.51zM11 9.663v.552H4.4v-.552H11zM8.12 0c1.088 0 1.973.908 1.973 2 0 .467-.166.92-.466 1.277l-.015.017-.615.619L6.215 1.12l.617-.618C7.204.186 7.656 0 8.12 0z"
  })));
}
export default SvgCommonIconWrite;